import { Box } from "arkh";
import React, { PropsWithChildren } from "react";

export const PLUListItemSpacer = React.memo(InnerPLUListItemSpacer);

function InnerPLUListItemSpacer(props: PropsWithChildren<{ itemWidth: number }>) {
  return (
    <Box
      style={{
        flex: 1,
        maxWidth: props.itemWidth,
      }}
      space="xsmall"
    >
      {props.children}
    </Box>
  );
}
